<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Family Plan</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination"
      item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.planNo }}</td>
        <td class="text-xs-left">{{ props.item.noAdult }}</td>
        <td class="text-xs-left">{{ props.item.minNoChild }}</td>
        <td class="text-xs-left">{{ props.item.maxNoChild }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Family Plan<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="familyDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Family Plan</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :label="labels.planNo" v-model="familyForm.planNo" :items="planList" item-text="label" item-value="value" :error-messages="errors.first('scheme') ? errors.first('scheme') : errors.collect('planNo')" data-vv-name="planNo" :data-vv-as="labels.planNo" v-validate="'required'" :loading="planLoading"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="familyForm.noAdult" v-num-mask="{negative: true, intScale: 10, decScale: 0}" :label="labels.noAdult" :error-messages="errors.collect('noAdult')" data-vv-name="noAdult" :data-vv-as="labels.noAdult" v-validate="'required'"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="familyForm.minNoChild" v-num-mask="{negative: true, intScale: 10, decScale: 0}" :label="labels.minNoChild" :error-messages="errors.collect('minNoChild')" data-vv-name="minNoChild" :data-vv-as="labels.minNoChild" v-validate="maxValidation(familyForm.maxNoChild)"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="familyForm.maxNoChild" v-num-mask="{negative: true, intScale: 10, decScale: 0}" :label="labels.maxNoChild" :error-messages="errors.collect('maxNoChild')" data-vv-name="maxNoChild" :data-vv-as="labels.maxNoChild" v-validate="minValidation(familyForm.minNoChild)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Family Plan?
      <div class="title">{{deleteDuration}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      headers: [
        { text: 'Plan', value: 'PlanNo' },
        { text: 'Number of Adult', value: 'noAdult' },
        { text: 'Minimum Number of Child', value: 'minNoChild' },
        { text: 'Maximum Number of Child', value: 'maxNoChild' },
        TableConst.tableActionHeader
      ],
      familyForm: {
        scheme: null,
        planNo: null,
        noAdult: null,
        minNoChild: null,
        maxNoChild: null
      },
      labels: {
        scheme: 'Scheme',
        planNo: 'Package Plan*',
        noAdult: 'Number of Adult*',
        minNoChild: 'Minimum Number of Children*',
        maxNoChild: 'Maximum Number of Children*'
      },
      planList: [],
      planLoading: false,
      familyDialog: false,
      deleteDuration: '',
      promptRemove: false
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'required|mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'required|mask_max_value:' + max
    },
    async doInit() {
      this.familyForm.scheme = this.scheme
      await this.fetchData(this.scheme)
    },
    async fetchData(xscheme) {
      if (this.schemeMenu.init !== 1) {
        await this.$store.dispatch('schemeMenuInit', this.scheme)
      }
      const apiURI = this.schemeMenu.menu.getFamilyPlans
      if (apiURI) {
        try {
          const expand = {
            scheme: xscheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((familyPlan) => {
              const convertFamilyPLan = {
                scheme: familyPlan.scheme,
                planNo: familyPlan.planNo,
                noAdult: familyPlan.noAdult,
                minNoChild: familyPlan.minNoChild,
                maxNoChild: familyPlan.maxNoChild
              }
              this.items.push(convertFamilyPLan)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Family Plan')
      }
    },
    async doPlanList() {
      const apiURI = this.schemeMenu.menu.planList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme
          }
          this.planLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.planList = data.planList
          }
          this.planLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Plan List')
      }
    },
    async doNew() {
      this.resetMessages()
      this.familyForm.planNo = undefined
      this.familyDialog = true
      await this.doPlanList()
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.schemeMenu.menu.familyPlanCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.familyForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Create Product Duration')
      }
    },
    doClose() {
      this.resetMessages()
      this.familyForm.planNo = undefined
      this.familyForm.noAdult = null
      this.familyForm.minNoChild = null
      this.familyForm.maxNoChild = null
      this.familyDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedDelete = data
        this.deleteDuration = data.scheme + ' - ' + data.planNo
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.menu.familyPlanDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          planNo: this.selectedDelete.planNo,
          scheme: this.scheme,
          noAdult: this.selectedDelete.noAdult,
          minNoChild: this.selectedDelete.minNoChild,
          maxNoChild: this.selectedDelete.maxNoChild
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.loading = false
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Scheme Duration')
      }
    }
  },
  mounted() {
    Promise.all([this.doInit()])
    if (this.scheme === 'new') {
      this.newFamilyPlan = true
    }
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
